import { Typography } from 'fronton-react';
import React from 'react';
import { jc, jcm } from 'utils';
import { ImagePlaceholder, ImageFallback } from 'common/components';
import { Styles } from './styles';

export type BrandBadgeProps = {
  title: string;
  logoImg: string;
  variant?: 'general' | 'thin';
} & React.HTMLAttributes<HTMLElement>;

export const BrandBadge: React.FC<BrandBadgeProps> = ({
  title,
  logoImg,
  variant = 'general',
  className = '',
  ...htmlProps
}) => {
  const caption = `Все товары марки ${title}`;

  return (
    <div
      className={jcm({
        [className]: true,
        [Styles.componentContainer]: true,
        [Styles.componentContainerThin]: variant === 'thin',
      })}
      {...htmlProps}
    >
      <div className={jc(Styles.logoImageContainer)}>
        <ImagePlaceholder
          className={jc(Styles.vendorLogoImg)}
          src={logoImg}
          loading="lazy"
          alt={title}
          fallback={<ImageFallback width={130} height={60} />}
        />
      </div>
      <div
        className={jcm({
          [Styles.titleContainer]: true,
          [Styles.titleContainerThin]: variant === 'thin',
        })}
      >
        <Typography className={Styles.titleContent} variant="s" size="body_short" color="text-secondary">
          {caption}
        </Typography>
      </div>
    </div>
  );
};
